/* عالم سمسم – مقارنة العطور: زرار المقارنة + شريط المقارنة العائم */
(function () {
  if (window.SMSMCMP) return;
  var KEY = 'smsm-compare', MAX = 4;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = ROOT + 'pages/compare-perfumes';
  var T = EN ? {
    add: 'Add to compare', added: 'In compare – tap to remove', toastAdd: 'Added to compare', toastRm: 'Removed from compare',
    full: 'You can compare up to 4 perfumes', cmp: 'Compare now', clear: 'Clear', need: 'Add one more perfume to compare', slots: 'Compare perfumes'
  } : {
    add: 'أضف للمقارنة', added: 'في المقارنة – اضغط للإزالة', toastAdd: 'اتضاف للمقارنة', toastRm: 'اتشال من المقارنة',
    full: 'تقدر تقارن لحد 4 عطور بس', cmp: 'قارن دلوقتي', clear: 'مسح', need: 'ضيف عطر كمان عشان تقارن', slots: 'مقارنة العطور'
  };
  function load() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }).slice(0, MAX) : []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} render(); sync(); try { window.dispatchEvent(new CustomEvent('smsm:compare', { detail: a })); } catch (e) {} }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function handleFrom(btn) {
    var card = btn.closest('.product-item, .product-card, [data-product-handle]');
    if (card) {
      if (card.dataset && card.dataset.productHandle) return card.dataset.productHandle;
      var a = card.querySelector('a[href*="/products/"]');
      if (a) { var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (m) return decodeURIComponent(m[1]); }
    }
    var m2 = location.pathname.match(/\/products\/([^/?#]+)/);
    return m2 ? decodeURIComponent(m2[1]) : null;
  }
  function getInfo(h) {
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return { h: h, t: h, i: '' };
      var img = p.featured_image || ''; if (img.indexOf('//') === 0) img = 'https:' + img;
      return { h: h, t: p.title, i: img };
    }).catch(function () { return { h: h, t: h, i: '' }; });
  }
  function toggle(h) {
    var a = load(), i = -1;
    a.forEach(function (x, k) { if (x.h === h) i = k; });
    if (i > -1) { a.splice(i, 1); save(a); toast(T.toastRm); return; }
    if (a.length >= MAX) { toast(T.full); openBar(); return; }
    a.push({ h: h, t: '', i: '' }); save(a); toast(T.toastAdd); openBar();
    getInfo(h).then(function (info) { var b = load(); b.forEach(function (x) { if (x.h === h) { x.t = info.t; x.i = info.i; } }); try { localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {} render(); });
  }

  /* شكل الزرار حسب الحالة */
  function sync() {
    document.querySelectorAll('button-compare, .product-item__button-compare').forEach(function (b) {
      var h = b.dataset.smsmHandle || handleFrom(b); if (!h) return; b.dataset.smsmHandle = h;
      var on = has(h);
      b.classList.toggle('smsm-cmp-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.added : T.add);
      var tip = b.querySelector('.tooltip-content'), tx = on ? T.added : T.add; if (tip && tip.textContent !== tx) tip.textContent = tx;
    });
  }

  /* الشريط العائم */
  var bar, tq;
  function css() {
    if (document.getElementById('smsm-cmp-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-cmp-css';
    s.textContent = '' +
      'button-compare.smsm-cmp-on,.product-item__button-compare.smsm-cmp-on{background:#512E83!important;border-color:#512E83!important;color:#fff!important}' +
      'button-compare.smsm-cmp-on svg,.product-item__button-compare.smsm-cmp-on svg{color:#fff;stroke:#fff}' +
      '.smsm-cmpbar{position:fixed;inset-inline:12px;bottom:calc(76px + env(safe-area-inset-bottom));z-index:60;max-width:720px;margin:0 auto;background:#fff;border:1px solid #E6DDF1;border-radius:18px;box-shadow:0 12px 34px rgba(58,31,97,.18);padding:10px 12px;display:flex;align-items:center;gap:10px;font-family:var(--body-font,inherit);transform:translateY(140%);opacity:0;transition:transform .35s cubic-bezier(.3,1,.3,1),opacity .25s;pointer-events:none}' +
      '.smsm-cmpbar.is-on{transform:none;opacity:1;pointer-events:auto}' +
      '.smsm-cmpbar__ttl{font-size:12.5px;font-weight:800;color:#3A1F61;white-space:nowrap}' +
      '.smsm-cmpbar__slots{display:flex;gap:6px;flex:1;min-width:0}' +
      '.smsm-cmpbar__s{position:relative;width:46px;height:46px;flex:0 0 46px;border-radius:12px;border:1px dashed #D9CDE8;background:#FBF8FD;display:flex;align-items:center;justify-content:center;color:#B9AECB;font-size:18px}' +
      '.smsm-cmpbar__s img{width:100%;height:100%;object-fit:contain;border-radius:11px;background:#fff}' +
      '.smsm-cmpbar__s.full{border-style:solid;border-color:#E6DDF1}' +
      '.smsm-cmpbar__x{position:absolute;top:-6px;inset-inline-end:-6px;width:18px;height:18px;border-radius:50%;background:#3A1F61;color:#fff;border:0;font-size:11px;line-height:18px;padding:0;cursor:pointer}' +
      '.smsm-cmpbar__go{border:0;border-radius:999px;background:#512E83;color:#fff;font-weight:800;font-size:13.5px;padding:11px 18px;cursor:pointer;white-space:nowrap;text-decoration:none}' +
      '.smsm-cmpbar__go[aria-disabled=true]{background:#CFC4DE;cursor:default}' +
      '.smsm-cmpbar__clr{border:0;background:none;color:#8C82A3;font-size:12px;font-weight:700;cursor:pointer;padding:4px}' +
      '.smsm-cmptoast{position:fixed;left:50%;bottom:calc(150px + env(safe-area-inset-bottom));transform:translate(-50%,10px);background:#1E1530;color:#fff;font-size:13px;font-weight:700;padding:9px 16px;border-radius:999px;z-index:61;opacity:0;transition:all .25s;pointer-events:none;font-family:var(--body-font,inherit)}' +
      '.smsm-cmptoast.is-on{opacity:1;transform:translate(-50%,0)}' +
      '@media(min-width:990px){.smsm-cmpbar{bottom:20px}.smsm-cmptoast{bottom:110px}.smsm-cmpbar__s{width:54px;height:54px;flex-basis:54px}}' +
      '@media(max-width:420px){.smsm-cmpbar__ttl{display:none}.smsm-cmpbar__s{width:40px;height:40px;flex-basis:40px}}' +
      '@media(max-width:1024.98px){.product-item button-compare.hidden,.product-item .product-item__button-compare.hidden{display:inline-flex!important}.product-item__button-action .product-item__button{width:38px!important;height:38px!important}.product-item__button-action .product-item__button svg{width:15px;height:15px}.product-item__button-action .tooltip-content{display:none!important}}' +
      '.smsm-wltoast a{color:#F3E3A6;text-decoration:underline;margin-inline-start:8px;pointer-events:auto}';
    document.head.appendChild(s);
  }
  function render() {
    if (/\/pages\/compare-perfumes/.test(location.pathname)) return;
    var a = load();
    if (!bar) {
      if (!a.length) return;
      css(); bar = document.createElement('div'); bar.className = 'smsm-cmpbar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', T.slots); bar.dir = EN ? 'ltr' : 'rtl';
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var x = e.target.closest('[data-rm]'); if (x) { e.preventDefault(); var b = load().filter(function (y) { return y.h !== x.dataset.rm; }); save(b); return; }
        if (e.target.closest('[data-clr]')) { e.preventDefault(); save([]); return; }
        var g = e.target.closest('.smsm-cmpbar__go'); if (g && load().length < 2) { e.preventDefault(); toast(T.need); }
      });
    }
    var slots = '';
    for (var k = 0; k < MAX; k++) {
      var x = a[k];
      slots += x ? '<span class="smsm-cmpbar__s full" title="' + esc(x.t) + '">' + (x.i ? '<img src="' + esc(x.i) + (x.i.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="' + esc(x.t) + '">' : '') + '<button type="button" class="smsm-cmpbar__x" data-rm="' + esc(x.h) + '" aria-label="remove">×</button></span>' : '<span class="smsm-cmpbar__s">+</span>';
    }
    bar.innerHTML = '<span class="smsm-cmpbar__ttl">' + T.slots + '</span><span class="smsm-cmpbar__slots">' + slots + '</span>' +
      '<button type="button" class="smsm-cmpbar__clr" data-clr>' + T.clear + '</button>' +
      '<a class="smsm-cmpbar__go" href="' + PAGE + '"' + (a.length < 2 ? ' aria-disabled="true"' : '') + '>' + T.cmp + (a.length ? ' (' + a.length + ')' : '') + '</a>';
    bar.classList.toggle('is-on', a.length > 0);
  }
  function openBar() { render(); }
  var tt;
  function toast(msg) {
    css(); var t = document.querySelector('.smsm-cmptoast');
    if (!t) { t = document.createElement('div'); t.className = 'smsm-cmptoast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('is-on'); }, 1800);
  }

  /* نمسك ضغطة زرار المقارنة قبل الثيم */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button-compare, .product-item__button-compare');
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var h = b.dataset.smsmHandle || handleFrom(b); if (!h) return;
    b.dataset.smsmHandle = h; toggle(h);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('button-compare, .product-item__button-compare'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); var h = b.dataset.smsmHandle || handleFrom(b); if (h) { b.dataset.smsmHandle = h; toggle(h); }
  }, true);

  /* المفضلة: عداد الهيدر + رسالة تأكيد */
  var WLKEY = 'glozin__wishlist-items';
  function wlList() { try { var a = JSON.parse(localStorage.getItem(WLKEY) || '[]'); return Array.isArray(a) ? a.filter(Boolean) : []; } catch (e) { return []; } }
  function wlBadge() {
    var n = wlList().length;
    document.querySelectorAll('[data-smsm-wishlist-badge], [data-smsm-wishlist-count], .smsm-wishlist-count, .header__wishlist .wishlist-count').forEach(function (el) {
      if (el.textContent.trim() !== String(n)) el.textContent = n;
      el.setAttribute('aria-label', n + (EN ? ' wishlist items' : ' في المفضلة'));
      el.classList.toggle('is-empty', n === 0);
    });
  }
  var wlT;
  function wlToast(added) {
    css(); var t = document.querySelector('.smsm-cmptoast');
    if (!t) { t = document.createElement('div'); t.className = 'smsm-cmptoast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.classList.add('smsm-wltoast');
    t.innerHTML = (added ? (EN ? 'Added to wishlist' : 'اتضاف للمفضلة') : (EN ? 'Removed from wishlist' : 'اتشال من المفضلة')) +
      (added ? '<a href="' + ROOT + 'pages/wishlist">' + (EN ? 'View' : 'عرض المفضلة') + '</a>' : '');
    t.classList.add('is-on'); clearTimeout(tt); clearTimeout(wlT);
    wlT = setTimeout(function () { t.classList.remove('is-on'); t.classList.remove('smsm-wltoast'); }, 2200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button-wishlist, .product-item__button-wishlist');
    if (!b) return;
    var id = b.dataset.productId, before = id ? wlList().indexOf(id) > -1 : null;
    setTimeout(function () {
      wlBadge();
      if (id == null) return;
      var after = wlList().indexOf(id) > -1;
      if (after !== before) {
        wlToast(after);
        document.querySelectorAll('button-wishlist[data-product-id="' + id + '"]').forEach(function (x) { x.classList.toggle('active', after); });
      }
    }, 120);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === WLKEY) wlBadge(); });
  window.addEventListener('pageshow', wlBadge);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { render(); sync(); } });
  function boot() { css(); sync(); render(); wlBadge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if ('MutationObserver' in window) { var mo = new MutationObserver(function () { clearTimeout(tq); tq = setTimeout(function () { sync(); wlBadge(); }, 250); }); document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); }); }
  window.SMSMCMP = { load: load, save: save, toggle: toggle, KEY: KEY, MAX: MAX };
})();
